module.exports = __webpack_public_path__ + "static/01-d3e6a52981938fb7fb8f355a85e4674a.png";